import { Message, MessageBox, Loading } from 'element-ui';

export default class {
  /**
   * 通知
   * @param {提示信息} msg
   * @param {Message默认参数} options
   */
  toast(msg, type = 'success', options = {}) {
    let MessageComponent = Message({ type: type, message: msg, ...options });
    //为了利于拓展，集中式定义style属性
    let style = options['style'];
    if (style) {
      if (this.isJson(style)) {
        for (let attr in style) {
          MessageComponent.dom.style[attr] = style[attr];
        }
      }
    }
    return MessageComponent;
  }
  /**
   * loading
   * @param {*} text
   * @returns
   */
  loading(text) {
    return Loading.service({ lock: true, text: text || 'Loading', spinner: 'el-icon-loading' });
  }
  /**
   * 消息提示
   * @param {提示信息} msg
   * @param {Confirm默认参数} options
   */
  alert(msg, options, title = '提示') {
    return MessageBox.alert(msg, title, { confirmButtonText: '确定', ...options });
  }
  /**
   * 确认消息
   * @param {提示信息} msg
   * @param {Confirm默认参数} options
   */
  confirm(msg, options = {}) {
    return MessageBox.confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      ...options,
    });
  }
  /**
   * 提交内容
   * @param {提示信息} msg
   * @param {Confirm默认参数} options
   */
  prompt(msg, options = {}) {
    return MessageBox.prompt(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      ...options,
    });
  }
  /**
   * 复制数组对象，仅对不含方法的对象有效
   * @param {数组对象} arrObj
   */
  copy(arrObj) {
    return JSON.parse(JSON.stringify(arrObj));
  }
  /**
   * 是否空，不包含0
   * @param {value} value
   */
  isNull(value) {
    return value === '' || value === null || value === undefined;
  }
  /**
   * 去掉前后空格
   * @param {Any} args - 一般传数组或对象
   */
  trim(args) {
    //如果是数组
    if (Array.isArray(args)) {
      args.forEach((ele, index) => {
        if (Array.isArray(ele) || typeof ele === 'object') {
          this.trim(ele);
        } else if (typeof ele === 'string') {
          args[index] = ele.trim();
        }
      });
    } else if (args != null && typeof args === 'object') {
      Object.keys(args).forEach(k => {
        let ele = args[k];
        if (Array.isArray(ele) || typeof ele === 'object') {
          this.trim(ele);
        } else if (typeof ele === 'string') {
          args[k] = ele.trim();
        }
      });
    } else if (typeof args === 'string') {
      return args.trim();
    }
  }
  /**
   * 严格检测是否json对象
   * @param {Any} obj - 要检测的对象
   */
  isJson(obj) {
    return typeof obj == 'object' && Object.prototype.toString.call(obj).toLowerCase() == '[object object]' && !obj.length;
  }
  /**
   * 获取cookie值
   * @param {String} key  - cookie名称
   */
  getCookie(key) {
    var str = '(^| )' + key + '=([^;]+)(;|$)';
    var reg = new RegExp(str);
    var arr = document.cookie.match(reg);
    if (!arr) return null;
    return arr[2];
  }
  /**
   * 设置cookie值
   * @param {String} name - 名称
   * @param {String} value - 值
   * @param {Object} day - 参数
   */
  setCookie(name, value, { domain, path, expires }) {
    let arr = [];
    if (domain) arr.push('domain=' + domain);
    if (path) arr.push('path=' + domain);
    if (expires) arr.push('expires=' + expires.toUTCString());
    let str = arr.length > 0 ? arr.join('; ') : '';

    document.cookie = `${name}=${value};${str}`;
  }
  /**
   * 删除cookie
   * @param {String} name - 名称
   */
  delCookie(name) {
    let today = new Date();
    today.setDate(today.getDate() - 1);
    this.setCookie(name, '', {
      expires: today,
    });
  }
  clipboard(text) {
    let id = 'unique-id-clipboard-copyText';
    let copyText = document.getElementById(id);
    if (!copyText) {
      copyText = document.createElement('input');
      copyText.id = id;
      copyText.style = 'position:absolute;left:-9999px';
      document.body.appendChild(copyText);
    }
    copyText.value = text;
    copyText.select();
    copyText.setSelectionRange(0, copyText.value.length);
    document.execCommand('copy');
  }
}
